

const emailRegex = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);
const mobileRegex = RegExp(/^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[4])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/ )

export const isValidEmail = (email) => {
    return emailRegex.test(email);
}

export const isValidMobile = (number) => {
    return mobileRegex.test(number)
}